import { productAccessorGetRedPointsRedPointsAmountWithMultiplier } from '../../../model/productAccessor/productAccessorGetRedPointsRedPointsAmountWithMultiplier'
import { productAccessorIsPrescriptionProduct } from '../../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../../productPageContext'

export const useRedPointsAmount = (): number => {
  const { currentOffer, currentVariant } = useProductPageContext()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)

  if (!isPrescriptionProduct && currentOffer) {
    return productAccessorGetRedPointsRedPointsAmountWithMultiplier(
      currentOffer,
    )
  }

  return 0
}
